/*
  This util should only be used with dev tools or in a very controlled internal use case.
  It is not intended for use in production code.

  This util simulates a user updating the value of a text input in react, one character at a time (as if typing).
  This tool does not leverage keyboard events, but rather directly sets the value of the input element.
  This is necessary because react does not always update the value of the input element when using keyboard events.
*/

export async function setReactTextInputValue(inputName: string, value: string) {
  const inputElement = document.querySelector(
    `input[name="${inputName}"]`
  ) as HTMLInputElement;

  if (inputElement) {
    const nativeInputValue = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    );

    // we have to directly reference the setter to allow overriding of the react input value
    /* eslint-disable-next-line @typescript-eslint/unbound-method */
    const nativeInputValueSetter = nativeInputValue?.set;

    if (nativeInputValueSetter) {
      for (let i = 0; i < value.length; i++) {
        // simulate typing by setting the value one character at a time
        const currentValue = value.slice(0, i + 1);

        // we set the context of `this` to the input element to enable setting the value
        nativeInputValueSetter.call(inputElement, currentValue);
        inputElement.dispatchEvent(
          new Event('input', {
            bubbles: true,
          })
        );

        await new Promise(resolve => setTimeout(resolve, 0));
      }

      inputElement.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    }
  } else {
    console.error(`${inputName} input not found in DOM`);
  }
}
